export const cluster = `!(function (t, e) {
  typeof exports == 'object' && typeof module != 'undefined'
    ? (module.exports = e())
    : typeof define == 'function' && define.amd
      ? define(e)
      : ((t = typeof globalThis != 'undefined' ? globalThis : t || self).Cluster = e())
})(this, function () {
  'use strict'
  class t {
    constructor(e) {
      this._hashCode = e != null ? e : t.guid()
    }
    getHandlers(t) {
      const e = this._events || (this._events = new Map())
      return e.has(t) || e.set(t, new Map()), e.get(t)
    }
    on(e, s) {
      if (typeof s != 'function') return
      this.getHandlers(e).set(s, t.guid())
    }
    addEventListener(t, e) {
      this.on(t, e)
    }
    off(t, e) {
      let s
      const i = this.getHandlers(t)
      e ? i.has(e) && i.delete(e) : (s = this._events) === null || void 0 === s || s.clear()
    }
    removeEventListener(t, e) {
      this.off(t, e)
    }
    fire(t, e) {
      const s = Array.from(this.getHandlers(t).entries())
      for (const [t] of s) t.call(this, e)
    }
    dispatchEvent(t, e) {
      this.fire(t, e)
    }
    destroy() {
      let t
      ;(t = this._events) === null || void 0 === t || t.clear(), (this._events = null)
    }
    get hashCode() {
      return this._hashCode
    }
    static guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (t) {
        const e = (16 * Math.random()) | 0
        return (t == 'x' ? e : (3 & e) | 8).toString(16)
      })
    }
  }
  let e, s, i, r
  !(function (t) {
    ;(t.CLICK = 'click'), (t.MOUSE_OVER = 'mouseover'), (t.MOUSE_OUT = 'mouseout'), (t.CHANGE = 'change'), (t.DESTROY = 'destroy')
  })(e || (e = {})),
    (function (t) {
      ;(t.DIS_PIXEL = 'dis-pixel'), (t.ATTR_REF = 'attribute'), (t.GEO_FENCE = 'geo-fence')
    })(s || (s = {})),
    (function (t) {
      ;(t.DOM = 'dom'), (t.WEBGL = 'webgl')
    })(i || (i = {})),
    (function (t) {
      ;(t.MULTI = 'multi'), (t.SINGLE = 'single')
    })(r || (r = {}))
  const o = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array]
  class n {
    static from(t) {
      if (!(t instanceof ArrayBuffer)) throw new Error('Data must be an instance of ArrayBuffer.')
      const [e, s] = new Uint8Array(t, 0, 2)
      if (e !== 219) throw new Error('Data does not appear to be in a KDBush format.')
      const i = s >> 4
      if (i !== 1) throw new Error('Got v'+i+' data when expected v1.')
      const r = o[15 & s]
      if (!r) throw new Error('Unrecognized array type.')
      const [l] = new Uint16Array(t, 2, 1)
      const [h] = new Uint32Array(t, 4, 1)
      return new n(h, l, r, t)
    }
    constructor(t, e = 64, s = Float64Array, i) {
      if (isNaN(t) || t < 0) throw new Error('Unpexpected numItems value: '+t)
      ;(this.numItems = +t),
        (this.nodeSize = Math.min(Math.max(+e, 2), 65535)),
        (this.ArrayType = s),
        (this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array)
      const r = o.indexOf(this.ArrayType)
      const n = 2 * t * this.ArrayType.BYTES_PER_ELEMENT
      const l = t * this.IndexArrayType.BYTES_PER_ELEMENT
      const h = (8 - (l % 8)) % 8
      if (r < 0) throw new Error('Unexpected typed array class:'+s)
      i && i instanceof ArrayBuffer
        ? ((this.data = i),
          (this.ids = new this.IndexArrayType(this.data, 8, t)),
          (this.coords = new this.ArrayType(this.data, 8 + l + h, 2 * t)),
          (this._pos = 2 * t),
          (this._finished = !0))
        : ((this.data = new ArrayBuffer(8 + n + l + h)),
          (this.ids = new this.IndexArrayType(this.data, 8, t)),
          (this.coords = new this.ArrayType(this.data, 8 + l + h, 2 * t)),
          (this._pos = 0),
          (this._finished = !1),
          new Uint8Array(this.data, 0, 2).set([219, 16 + r]),
          (new Uint16Array(this.data, 2, 1)[0] = e),
          (new Uint32Array(this.data, 4, 1)[0] = t))
    }
    add(t, e) {
      const s = this._pos >> 1
      return (this.ids[s] = s), (this.coords[this._pos++] = t), (this.coords[this._pos++] = e), s
    }
    finish() {
      const t = this._pos >> 1
      if (t !== this.numItems) throw new Error('Added '+t+' items when expected '+this.numItems)
      return l(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), (this._finished = !0), this
    }
    range(t, e, s, i) {
      if (!this._finished) throw new Error('Data not yet indexed - call index.finish().')
      const { ids: r, coords: o, nodeSize: n } = this
      const l = [0, r.length - 1, 0]
      const h = []
      for (; l.length; ) {
        const a = l.pop() || 0
        const u = l.pop() || 0
        const c = l.pop() || 0
        if (u - c <= n) {
          for (let n = c; n <= u; n++) {
            const l = o[2 * n]
            const a = o[2 * n + 1]
            l >= t && l <= s && a >= e && a <= i && h.push(r[n])
          }
          continue
        }
        const p = (c + u) >> 1
        const g = o[2 * p]
        const d = o[2 * p + 1]
        g >= t && g <= s && d >= e && d <= i && h.push(r[p]),
          (a === 0 ? t <= g : e <= d) && (l.push(c), l.push(p - 1), l.push(1 - a)),
          (a === 0 ? s >= g : i >= d) && (l.push(p + 1), l.push(u), l.push(1 - a))
      }
      return h
    }
    within(t, e, s) {
      if (!this._finished) throw new Error('Data not yet indexed - call index.finish().')
      const { ids: i, coords: r, nodeSize: o } = this
      const n = [0, i.length - 1, 0]
      const l = []
      const h = s * s
      for (; n.length; ) {
        const a = n.pop() || 0
        const u = n.pop() || 0
        const p = n.pop() || 0
        if (u - p <= o) {
          for (let s = p; s <= u; s++) c(r[2 * s], r[2 * s + 1], t, e) <= h && l.push(i[s])
          continue
        }
        const g = (p + u) >> 1
        const d = r[2 * g]
        const y = r[2 * g + 1]
        c(d, y, t, e) <= h && l.push(i[g]),
          (a === 0 ? t - s <= d : e - s <= y) && (n.push(p), n.push(g - 1), n.push(1 - a)),
          (a === 0 ? t + s >= d : e + s >= y) && (n.push(g + 1), n.push(u), n.push(1 - a))
      }
      return l
    }
  }
  function l(t, e, s, i, r, o) {
    if (r - i <= s) return
    const n = (i + r) >> 1
    h(t, e, n, i, r, o), l(t, e, s, i, n - 1, 1 - o), l(t, e, s, n + 1, r, 1 - o)
  }
  function h(t, e, s, i, r, o) {
    for (; r > i; ) {
      if (r - i > 600) {
        const n = r - i + 1
        const l = s - i + 1
        const a = Math.log(n)
        const u = 0.5 * Math.exp((2 * a) / 3)
        const c = 0.5 * Math.sqrt((a * u * (n - u)) / n) * (l - n / 2 < 0 ? -1 : 1)
        h(t, e, s, Math.max(i, Math.floor(s - (l * u) / n + c)), Math.min(r, Math.floor(s + ((n - l) * u) / n + c)), o)
      }
      const n = e[2 * s + o]
      let l = i
      let u = r
      for (a(t, e, i, s), e[2 * r + o] > n && a(t, e, i, r); l < u; ) {
        for (a(t, e, l, u), l++, u--; e[2 * l + o] < n; ) l++
        for (; e[2 * u + o] > n; ) u--
      }
      e[2 * i + o] === n ? a(t, e, i, u) : (u++, a(t, e, u, r)), u <= s && (i = u + 1), s <= u && (r = u - 1)
    }
  }
  function a(t, e, s, i) {
    u(t, s, i), u(e, 2 * s, 2 * i), u(e, 2 * s + 1, 2 * i + 1)
  }
  function u(t, e, s) {
    const i = t[e]
    ;(t[e] = t[s]), (t[s] = i)
  }
  function c(t, e, s, i) {
    const r = t - s
    const o = e - i
    return r * r + o * o
  }
  function p(t) {
    return !isNaN(t) && t !== null && !Array.isArray(t)
  }
  function g(t, e, s) {
    if (t !== null) {
      for (
        var i, r, o, n, l, h, a, u, c = 0, p = 0, d = t.type, y = d === 'FeatureCollection', m = d === 'Feature', f = y ? t.features.length : 1, w = 0;
        w < f;
        w++
      ) {
        l = (u = !!(a = y ? t.features[w].geometry : m ? t.geometry : t) && a.type === 'GeometryCollection') ? a.geometries.length : 1
        for (let _ = 0; _ < l; _++) {
          let E = 0
          let O = 0
          if ((n = u ? a.geometries[_] : a) !== null) {
            h = n.coordinates
            let M = n.type
            switch (((c = !s || (M !== 'Polygon' && M !== 'MultiPolygon') ? 0 : 1), M)) {
              case null:
                break
              case 'Point':
                if (!1 === e(h, p, w, E, O)) return !1
                p++, E++
                break
              case 'LineString':
              case 'MultiPoint':
                for (i = 0; i < h.length; i++) {
                  if (!1 === e(h[i], p, w, E, O)) return !1
                  p++, M === 'MultiPoint' && E++
                }
                M === 'LineString' && E++
                break
              case 'Polygon':
              case 'MultiLineString':
                for (i = 0; i < h.length; i++) {
                  for (r = 0; r < h[i].length - c; r++) {
                    if (!1 === e(h[i][r], p, w, E, O)) return !1
                    p++
                  }
                  M === 'MultiLineString' && E++, M === 'Polygon' && O++
                }
                M === 'Polygon' && E++
                break
              case 'MultiPolygon':
                for (i = 0; i < h.length; i++) {
                  for (O = 0, r = 0; r < h[i].length; r++) {
                    for (o = 0; o < h[i][r].length - c; o++) {
                      if (!1 === e(h[i][r][o], p, w, E, O)) return !1
                      p++
                    }
                    O++
                  }
                  E++
                }
                break
              case 'GeometryCollection':
                for (i = 0; i < n.geometries.length; i++) {
                  if (!1 === g(n.geometries[i], e, s)) return !1
                }
                break
              default:
                throw new Error('Unknown Geometry Type')
            }
          }
        }
      }
    }
  }
  function d(t) {
    let e = [1 / 0, 1 / 0, -1 / 0, -1 / 0]
    return (
      g(t, function (t) {
        e[0] > t[0] && (e[0] = t[0]), e[1] > t[1] && (e[1] = t[1]), e[2] < t[0] && (e[2] = t[0]), e[3] < t[1] && (e[3] = t[1])
      }),
      e
    )
  }
  function y(t, e, s) {
    if ((void 0 === s && (s = {}), !t)) throw new Error('point is required')
    if (!e) throw new Error('polygon is required')
    let i
    let r = (function (t) {
      if (!t) throw new Error('coord is required')
      if (!Array.isArray(t)) {
        if (t.type === 'Feature' && t.geometry !== null && t.geometry.type === 'Point') {
          return t.geometry.coordinates
        }
        if (t.type === 'Point') return t.coordinates
      }
      if (Array.isArray(t) && t.length >= 2 && !Array.isArray(t[0]) && !Array.isArray(t[1])) return t
      throw new Error('coord must be GeoJSON Point or an Array of numbers')
    })(t)
    let o = (i = e).type === 'Feature' ? i.geometry : i
    let n = o.type
    let l = e.bbox
    let h = o.coordinates
    if (
      l &&
      !1 ===
        (function (t, e) {
          return e[0] <= t[0] && e[1] <= t[1] && e[2] >= t[0] && e[3] >= t[1]
        })(r, l)
    )
      return !1
    n === 'Polygon' && (h = [h])
    for (var a = !1, u = 0; u < h.length && !a; u++) {
      if (m(r, h[u][0], s.ignoreBoundary)) {
        for (var c = !1, p = 1; p < h[u].length && !c; ) m(r, h[u][p], !s.ignoreBoundary) && (c = !0), p++
        c || (a = !0)
      }
    }
    return a
  }
  function m(t, e, s) {
    let i = !1
    e[0][0] === e[e.length - 1][0] && e[0][1] === e[e.length - 1][1] && (e = e.slice(0, e.length - 1))
    for (let r = 0, o = e.length - 1; r < e.length; o = r++) {
      let n = e[r][0]
      let l = e[r][1]
      let h = e[o][0]
      let a = e[o][1]
      if (t[1] * (n - h) + l * (h - t[0]) + a * (t[0] - n) == 0 && (n - t[0]) * (h - t[0]) <= 0 && (l - t[1]) * (a - t[1]) <= 0) return !s
      l > t[1] != a > t[1] && t[0] < ((h - n) * (t[1] - l)) / (a - l) + n && (i = !i)
    }
    return i
  }
  function f(t, e) {
    void 0 === e && (e = {})
    let s = 0
    let i = 0
    let r = 0
    return (
      g(
        t,
        function (t) {
          ;(s += t[0]), (i += t[1]), r++
        },
        !0
      ),
      (function (t, e, s) {
        if ((void 0 === s && (s = {}), !t)) throw new Error('coordinates is required')
        if (!Array.isArray(t)) throw new Error('coordinates must be an Array')
        if (t.length < 2) throw new Error('coordinates must be at least 2 numbers long')
        if (!p(t[0]) || !p(t[1])) throw new Error('coordinates must contain numbers')
        return (function (t, e, s) {
          void 0 === s && (s = {})
          let i = {
            type: 'Feature'
          }
          return (s.id === 0 || s.id) && (i.id = s.id), s.bbox && (i.bbox = s.bbox), (i.properties = e || {}), (i.geometry = t), i
        })(
          {
            type: 'Point',
            coordinates: t
          },
          e,
          s
        )
      })([s / r, i / r], e.properties)
    )
  }
  d.default = d
  const w = (t, e, s) => {
    let i
    let r
    let o
    let n = null
    let l = 0
    s || (s = {})
    const h = function () {
      ;(l = !1 === s.leading ? 0 : Date.now()), (n = null), (o = t.apply(r, i)), n || (r = i = null)
    }
    return function () {
      const a = Date.now()
      l || !1 !== s.leading || (l = a)
      const u = e - (a - l)
      return (
        (r = this),
        (i = arguments),
        u <= 0 || u > e
          ? (n && (clearTimeout(n), (n = null)), (l = a), (o = t.apply(r, i)), n || (r = i = null))
          : n || !1 === s.trailing || (n = setTimeout(h, u)),
        o
      )
    }
  }
  const _ = Math.fround || ((E = new Float32Array(1)), (t) => ((E[0] = +t), E[0]))
  let E
  const O = (t, e) =>
    t.reduce((t, s, i) => {
      let r = e(s)
      ;(r = r == null || r === '' ? 'undefined' : r), t[r] || (t[r] = [])
      const o = Object.assign({}, s)
      return (o.id = i), t[r].push(o), t
    }, {})
  const M = (t) => ({
    fence: !0,
    bbox: d(t),
    center: L(t)
  })
  const T = (t, e) => {
    if (e) {
      return d({
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Polygon',
              coordinates: [t]
            }
          }
        ]
      })
    }
    return d({
      type: 'FeatureCollection',
      features: t
    })
  }
  const L = (t) => f(t).geometry.coordinates
  const v = (t) => {
    if (!t || !Array.isArray(t) || t.length < 2) return []
    const e = [t[0], t[1]]
    for (let s = 2; s < t.length - 1; s += 2) {
      t[s] !== e[s - 2] && t[s + 1] !== e[s - 1] && e.push(t[s], t[s + 1])
    }
    return e
  }
  const x = (t) => t / 360 + 0.5
  const b = (t) => {
    const e = Math.sin((t * Math.PI) / 180)
    const s = 0.5 - (0.25 * Math.log((1 + e) / (1 - e))) / Math.PI
    return s < 0 ? 0 : s > 1 ? 1 : s
  }
  class F {
    constructor() {}
  }
  let C
  !(function (t) {
    ;(t[(t.NONE = 0)] = 'NONE'), (t[(t.INNER = 1)] = 'INNER'), (t[(t.OUT = 2)] = 'OUT'), (t[(t.ALL = 3)] = 'ALL')
  })(C || (C = {}))
  class S {
    constructor(t, s = !1) {
      ;(this.trees = {}),
        (this.nodeSize = 64),
        (this.isSort = !0),
        (this.splitChar = '*.*'),
        (this.isWeight = !1),
        (this.OFFSET_ZOOM = 2),
        (this.OFFSET_ID = 3),
        (this.OFFSET_PARENT = 4),
        (this.OFFSET_NUM = 5),
        (this.OFFSET_PROP = 6),
        (this.mapping = new Map()),
        (this.geo_refs = new Map()),
        (this.key_refs = new Map()),
        (this.cluster_geo_refs = new Map()),
        (this.own = t),
        (this.showLog = s),
        (this.reduceType = this.isClusterReduce()),
        (this.stride = this.reduceType !== C.NONE ? 7 : 6),
        this.isWeight &&
          ((this.innerReduce = (t, e) => {
            let s
            t.weight += (s = e == null ? void 0 : e.weight) !== null && void 0 !== s ? s : 1
          }),
          (this.innerMap = (t) => {
            let e
            return {
              weight: t ? ((e = t[this.weightKey]) !== null && void 0 !== e ? e : 1) : null
            }
          })),
        this.createZoomMapping(),
        this.own.on(e.DESTROY, () => {
          this.reset(), this.mapping.clear()
        })
    }
    isClusterReduce() {
      const t = this.own.getOptions().clusterPointWeight
      return t
        ? ((this.isWeight = !0), (this.weightKey = t), this.own.getOptions().clusterReduce ? C.ALL : C.INNER)
        : this.own.getOptions().clusterReduce
          ? C.OUT
          : C.NONE
    }
    createZoomMapping() {
      const t = this.own.getOptions().clusterType
      t &&
        t.length !== 0 &&
        (t.forEach((t) => {
          let [e, i, r, o, n] = t
          if (((i = i != null ? i : this.own.getOptions().clusterMaxZoom), r === s.GEO_FENCE || r === s.ATTR_REF))
            this.mapping.set(e, [n != null ? n : i, r, o])
          else if (n) this.mapping.set(e, [n, s.DIS_PIXEL, o])
          else {
            for (let l = e; l <= i; l++) this.mapping.set(l, [l, s.DIS_PIXEL, o])
          }
        }),
        this.showLog && console.log('this.mapping', this.mapping))
    }
    getClusterType(t) {
      let e
      let i = s.DIS_PIXEL
      for (const [r, o] of [...this.mapping.entries()].reverse()) {
        if (r <= t) {
          ;(i = o[1]), (e = i === s.ATTR_REF && o[2] instanceof Array ? o[2][o[2].length - 1] : o[2])
          break
        }
      }
      return {
        type: i,
        name: e
      }
    }
    getClusterZoom(t) {
      let e = this._limitZoom(t)
      for (const [s] of [...this.mapping.entries()].reverse()) {
        if (s <= t) {
          e = s
          break
        }
      }
      return e
    }
    getClusterTree(t) {
      const e = this.getClusterZoom(t)
      return this.trees[e]
    }
    createClusters(t) {
      this.reset(), (this.points = t)
      const { clusterMinZoom: e = 3, clusterMaxZoom: i = 21 } = this.own.getOptions()
      const r = 'prepare ' + t.length + ' points'
      this.showLog && console.time(r)
      const o = []
      for (let t = 0; t < this.points.length; t++) {
        const e = this.points[t]
        if (!e.geometry) continue
        const [s, i] = e.geometry.coordinates
        const r = _(s)
        const n = _(i)
        o.push(r, n, 1 / 0, t, -1, 1), this.reduceType !== C.NONE && o.push(-1)
      }
      let n = (this.trees[i + 1] = this._createTree(new Float32Array(o)))
      for (let t = i; t >= e; t--) {
        const e = +Date.now()
        const i = this.getClusterZoom(t)
        if (this.mapping.has(i)) {
          if (this.trees[i]) continue
          let t
          const [e, r, o] = this.mapping.get(i)
          switch (r) {
            case s.GEO_FENCE:
              t = this._fence_cluster(e, o)
              break
            case s.ATTR_REF:
              t = this._attribute_cluster(e, o)
              break
            default:
              t = this._distance_cluster(n, e)
          }
          n = this.trees[i] = this._createTree(t)
        } else n = this.trees[i] = this._createTree(this._distance_cluster(n, i))
        this.showLog && console.log('z%d: %d clusters in %dms', t, n.numItems, +Date.now() - e)
      }
      this.showLog && console.timeEnd(r)
    }
    _createTree(t) {
      const e = new n((t.length / this.stride) | 0, this.nodeSize, Float32Array)
      for (let s = 0; s < t.length; s += this.stride) e.add(x(t[s]), b(t[s + 1]))
      return e.finish(), (e.data = t), e
    }
    _attribute_cluster(t, e) {
      const i = O(this.points, (t) => {
        if (!t.properties) return null
        let i = null
        if (
          (e instanceof Array
            ? e.forEach((e) => {
                let s
                ;((s = t.properties) === null || void 0 === s ? void 0 : s.hasOwnProperty(e)) &&
                  (i === null ? (i = t.properties[e]) : (i += this.splitChar + t.properties[e]))
              })
            : (i = t.properties[e]),
          this.own.getOptions().clusterDictionary && i && !this.geo_refs.has(i))
        ) {
          const t = this.own.getOptions().clusterDictionary(s.ATTR_REF, i)
          t && t.point && this.geo_refs.set(i, t)
        }
        return i
      })
      this.showLog && console.log('attribute_cluster', t, i)
      return this._match_cluster(s.ATTR_REF, i, t)
    }
    _fence_cluster(t, e) {
      const i = new Map()
      if (this.own.getOptions().clusterDictionary) {
        let t = e
        t instanceof Array || (t = [t]),
          t.forEach((t) => {
            if (this.geo_refs.has(t)) i.set(t, this.geo_refs.get(t))
            else {
              this.showLog && console.log('fence_cluster_key', t)
              const e = this.own.getOptions().clusterDictionary(s.GEO_FENCE, t)
              e && e.region && (e.point || (e.point = L(e.region)), this.geo_refs.set(t, e), i.set(t, e))
            }
          })
      }
      const r = O(this.points, (t) =>
        ((t, e, s) => {
          let i = null
          for (const [r, o] of t) {
            const t = s(o)
            const n = y(e, t)
            if ((console.log(n, e, t), n)) {
              i = r
              break
            }
          }
          return i
        })(i, t, (t) => ({
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [t.region]
          }
        }))
      )
      this.showLog && console.log('fence_cluster', r)
      return this._match_cluster(s.GEO_FENCE, r, t)
    }
    _match_cluster(t, e, i) {
      const r = []
      const { clusterMinPoints: o = 3, clusterReduce: n } = this.own.getOptions()
      for (const l in e) {
        if (e.hasOwnProperty(l)) {
          const h = e[l]
          if (l === 'undefined' || h.length < o) {
            h.forEach((t) => {
              let e
              const [s, i] = t.geometry.coordinates
              const o = s
              const n = i
              r.push(o, n, 1 / 0, +((e = t.id) !== null && void 0 !== e ? e : 0), -1, 1), this.reduceType !== C.NONE && r.push(-1)
            })
          } else {
            let e
            let a = -1
            h.forEach((t) => {
              if (this.reduceType !== C.NONE) {
                let s = {}
                if ((this.isWeight && (s = this.innerMap(t.properties)), n)) {
                  const e = this.own.getOptions().clusterMap(t.properties)
                  Object.assign(s, e)
                }
                e
                  ? (this.isWeight && this.innerReduce(e, Object.assign({}, s)), n && n(e, Object.assign({}, s)))
                  : ((e = Object.assign({}, s)), (a = this.clusterProps.length), this.clusterProps.push(e))
              }
            })
            let u = (h[0].id << 5) + (i + 1) + this.points.length
            const c = l.split(this.splitChar)
            if ((this.key_refs.set(u, c[c.length - 1]), this.geo_refs.has(l))) {
              const e = this.geo_refs.get(l)
              const i = e.point
              r.push(i[0], i[1], 1 / 0, u, -1, h.length),
                t === s.GEO_FENCE
                  ? this.cluster_geo_refs.set(u, {
                      bbox: T(e.region, !0)
                    })
                  : this.cluster_geo_refs.set(u, {
                      bbox: T(h, !1)
                    })
            } else {
              const {
                fence: t,
                bbox: e,
                center: s
              } = M({
                type: 'FeatureCollection',
                features: h
              })
              v(e).length <= 2 || e[0] === 1 / 0 || !t
                ? (o > 1 && (u = h[0].id), r.push(s[0], s[1], 1 / 0, u, -1, 1))
                : r.push(s[0], s[1], 1 / 0, u, -1, h.length),
                this.cluster_geo_refs.set(u, {
                  bbox: e
                })
            }
            this.reduceType !== C.NONE && r.push(a)
          }
        }
      }
      return r
    }
    _distance_cluster(t, e) {
      let s, i, r, o, n, l
      const { clusterRadius: h = 60, tileSize: a = 256, clusterMinPoints: u = 3, clusterReduce: c } = this.own.getOptions()
      const p = h / (a * Math.pow(2, e - 1))
      const g = t.data
      const d = []
      const y = this.stride
      for (let h = 0; h < g.length; h += y) {
        if (g[h + this.OFFSET_ZOOM] <= e) continue
        g[h + this.OFFSET_ZOOM] = e
        const a = g[h]
        const m = g[h + 1]
        const f = t.within(x(g[h]), b(g[h + 1]), p)
        const w = g[h + this.OFFSET_NUM]
        let _ = w
        const E =
          this.isWeight && (i = (s = this.clusterProps[g[h + this.OFFSET_PROP]]) === null || void 0 === s ? void 0 : s.weight) !== null && void 0 !== i ? i : 1
        let O = E
        for (const t of f) {
          const s = t * y
          g[s + this.OFFSET_ZOOM] > e &&
            ((_ += g[s + this.OFFSET_NUM]),
            (O +=
              this.isWeight && (o = (r = this.clusterProps[g[s + this.OFFSET_PROP]]) === null || void 0 === r ? void 0 : r.weight) !== null && void 0 !== o
                ? o
                : 1))
        }
        if (_ > w && _ >= u) {
          let t
          let s = a * (this.isWeight ? E : w)
          let i = m * (this.isWeight ? E : w)
          let r = -1
          const o = [[a, m]]
          const u = ((h / y) << 5) + (e + 1) + this.points.length
          for (const a of f) {
            const p = a * y
            if (g[p + this.OFFSET_ZOOM] <= e) continue
            g[p + this.OFFSET_ZOOM] = e
            const d = g[p + this.OFFSET_NUM]
            const m =
              this.isWeight && (l = (n = this.clusterProps[g[p + this.OFFSET_PROP]]) === null || void 0 === n ? void 0 : n.weight) !== null && void 0 !== l
                ? l
                : 1
            if (
              ((s += g[p] * (this.isWeight ? m : d)),
              (i += g[p + 1] * (this.isWeight ? m : d)),
              o.push([g[p], g[p + 1]]),
              (g[p + this.OFFSET_PARENT] = u),
              this.reduceType !== C.NONE)
            ) {
              t || ((t = this._map(g, h, !0)), (r = this.clusterProps.length), this.clusterProps.push(t))
              const e = this._map(g, p)
              this.isWeight && this.innerReduce(t, e), c && c(t, e)
            }
          }
          ;(g[h + this.OFFSET_PARENT] = u),
            this.cluster_geo_refs.set(u, {
              bbox: T(o, !0)
            }),
            this.isWeight ? d.push(s / O, i / O, 1 / 0, u, -1, _) : d.push(s / _, i / _, 1 / 0, u, -1, _),
            this.reduceType !== C.NONE && d.push(r)
        } else {
          for (let t = 0; t < y; t++) d.push(g[h + t])
          if (_ > 1) {
            for (const t of f) {
              const s = t * y
              if (!(g[s + this.OFFSET_ZOOM] <= e)) {
                g[s + this.OFFSET_ZOOM] = e
                for (let t = 0; t < y; t++) d.push(g[s + t])
              }
            }
          }
        }
      }
      return d
    }
    _getOriginId(t) {
      return (t - this.points.length) >> 5
    }
    _getOriginZoom(t) {
      return (t - this.points.length) % 32
    }
    _map(t, e, s) {
      if (t[e + this.OFFSET_NUM] > 1) {
        const i = this.clusterProps[t[e + this.OFFSET_PROP]]
        return s ? Object.assign({}, i) : i
      }
      const i = this.points[t[e + this.OFFSET_ID]].properties
      let r = {}
      if ((this.isWeight && (r = this.innerMap(i)), this.own.getOptions().clusterReduce)) {
        const t = this.own.getOptions().clusterMap(i)
        Object.assign(r, t)
      }
      return s && r === i ? Object.assign({}, r) : r
    }
    _limitZoom(t) {
      let e, s
      const i = this.own.getOptions()
      return Math.max(
        (e = i.clusterMinZoom) !== null && void 0 !== e ? e : 3,
        Math.min(Math.floor(+t), ((s = i.clusterMaxZoom) !== null && void 0 !== s ? s : 21) + 1)
      )
    }
    getClusters(t, e) {
      if (this.isIllegal(t)) return [[], []]
      let i = ((((e[0] + 180) % 360) + 360) % 360) - 180
      const r = Math.max(-90, Math.min(90, e[1]))
      let o = e[2] === 180 ? 180 : ((((e[2] + 180) % 360) + 360) % 360) - 180
      const n = Math.max(-90, Math.min(90, e[3]))
      if (e[2] - e[0] >= 360) (i = -180), (o = 180)
      else if (i > o) {
        const e = this.getClusters(t, [i, r, 180, n])
        const s = this.getClusters(t, [-180, r, o, n])
        return [
          [...e[0], ...s[0]],
          [...e[1], ...s[1]]
        ]
      }
      const l = this.getClusterTree(t)
      if (!l) return [[], []]
      const { type: h, name: a } = this.getClusterType(t)
      const u = l.range(x(i), b(n), x(o), b(r))
      const c = l.data
      const p = []
      const g = []
      this.showLog && console.log('getClusters', u)
      for (const t of u) {
        const e = this.stride * t
        if (c[e + this.OFFSET_NUM] >= this.own.getOptions().clusterMinPoints) {
          const i = this.getClusterJSON(c, e, this.clusterProps)
          i.properties || (i.properties = {}),
            (i.properties.clusterIndex = t),
            (i.properties.allCount = this.points.length),
            (i.properties.type = h),
            (h !== s.GEO_FENCE && h !== s.ATTR_REF) ||
              (this.key_refs.has(c[e + this.OFFSET_ID]) &&
                ((i.properties.belongKey = a), (i.properties.belongValue = this.key_refs.get(c[e + this.OFFSET_ID])))),
            p.push(i)
        } else {
          const t = c[e + this.OFFSET_ID]
          const s = this.points[t]
          ;(s.id = t),
            s.properties
              ? (s.properties.clusterId = t)
              : (s.properties = {
                  clusterId: t
                }),
            s.properties
              ? (s.properties.allCount = this.points.length)
              : (s.properties = {
                  allCount: this.points.length
                }),
            g.push(s)
        }
      }
      return (
        this.isSort &&
          p.sort((t, e) => {
            let s, i
            return ((s = t.properties) === null || void 0 === s ? void 0 : s.pointCount) - ((i = e.properties) === null || void 0 === i ? void 0 : i.pointCount)
          }),
        [g, p]
      )
    }
    getElementById(t, e) {
      const i = new F()
      i.id = t
      const r = this._getOriginZoom(t) - 1
      const { type: o, name: n } = this.getClusterType(r)
      if (((i.type = o), t <= this.points.length)) {
        ;(i.isCluster = !1), (i.properties = this.points[t].properties), (i.latLng = this.points[t].geometry.coordinates)
      } else {
        i.isCluster = !0
        const l = this.getClusterTree(r)
        const h = l.data
        if (l) {
          const r = e * this.stride
          this.showLog && console.log('getElementById', h.slice(r, r + this.stride)),
            (i.latLng = [h[r], h[r + 1]]),
            (i.pointCount = h[r + this.OFFSET_NUM]),
            (o !== s.GEO_FENCE && o !== s.ATTR_REF) || (this.key_refs.has(t) && ((i.belongKey = n), (i.belongValue = this.key_refs.get(t)))),
            this.reduceType !== C.NONE && (i.reduces = this.clusterProps[h[r + this.OFFSET_PROP]])
        }
      }
      return this.cluster_geo_refs.has(t) && (i.bbox = this.cluster_geo_refs.get(t).bbox), this.showLog && console.log('getElementById', i), i
    }
    getChildren(t) {
      const e = this._getOriginId(t)
      const s = this._getOriginZoom(t)
      const i = 'No cluster with the specified id.'
      const r = this.trees[s]
      if (!r) throw new Error(i)
      const o = r.data
      if (e * this.stride >= o.length) throw new Error(i)
      const n = []
      if (n.length === 0) throw new Error(i)
      return n
    }
    getLeaves(t) {
      return []
    }
    getClusterJSON(t, e, s) {
      return {
        type: 'Feature',
        id: t[e + this.OFFSET_ID],
        properties: this.getClusterProperties(t, e, s),
        geometry: {
          type: 'Point',
          coordinates: [t[e], t[e + 1]]
        }
      }
    }
    getClusterProperties(t, e, s) {
      const i = t[e + this.OFFSET_NUM]
      const r = i >= 1e4 ? '+' + Math.round(i / 1e3) + 'k' : i >= 1e3 ? Math.round(i / 100) / 10 + 'k' : i
      let o = {}
      if (this.reduceType !== C.NONE) {
        const i = t[e + this.OFFSET_PROP]
        o =
          i === -1
            ? {}
            : Object.assign(
                {},
                {
                  reduces: s[i]
                }
              )
      }
      return Object.assign(o, {
        isCluster: !0,
        clusterId: t[e + this.OFFSET_ID],
        point: [t[e], t[e + 1]],
        pointCount: i,
        pointCountAbbrev: r
      })
    }
    isIllegal(t) {
      let e, s
      const i = (e = this.own.getOptions().minZoom) !== null && void 0 !== e ? e : 3
      const r = (s = this.own.getOptions().maxZoom) !== null && void 0 !== s ? s : 23
      return t < i || t > r
    }
    reset() {
      ;(this.points = []), (this.clusterProps = []), (this.trees = {}), this.geo_refs.clear(), this.key_refs.clear(), this.cluster_geo_refs.clear()
    }
  }
  class I {
    constructor(t, e, s, i) {
      ;(this._wait = 600),
        (this._fitViewMargin = [12, 12, 12, 12]),
        (this.own = t),
        (this.engine = e),
        (this.map = s),
        (this.showLog = i),
        this.register(),
        this.createLayers()
    }
    register() {
      this.own.getOptions().updateRealTime
        ? ((this._wait = this.own.getOptions().waitTime || 300),
          this.map.addEventListener(
            'update',
            (this._onMapStatusChange = w(this.mapStatusChange.bind(this), this._wait, {
              leading: !0,
              trailing: !1
            }))
          ))
        : this.map.addEventListener('mapstatusidle_inner', (this._onMapStatusChange = this.mapStatusChange.bind(this))),
        this.map.addEventListener('destroy', () => {
          this.own.destroy()
        }),
        this.own.on(e.DESTROY, () => {
          this.destroy()
        })
    }
    unregister() {
      this.own.getOptions().updateRealTime
        ? this.map.removeEventListener('update', this._onMapStatusChange)
        : this.map.removeEventListener('mapstatusidle_inner', this._onMapStatusChange),
        (this._onMapStatusChange = () => {})
    }
    mapStatusChange(t) {
      const s = this.map.getZoom()
      const i = this.map.getBounds()
      const r = i.getSouthWest()
      const o = i.getNorthEast()
      this.showLog && console.log('地图状态变化', s, [r.lng, r.lat, o.lng, o.lat])
      const n = this.engine.getClusters(s, [r.lng, r.lat, o.lng, o.lat])
      this.own.fire(e.CHANGE, n), this.own.isRender && this.update(n)
    }
    update(t) {
      this.showLog && console.log('更新数据', t), this.render(t[0], r.SINGLE), this.render(t[1], r.MULTI)
    }
    render(t, e) {
      this.showLog && console.log('渲染type', e), this.showLog && console.log('渲染data', t)
      const s = {
        type: 'FeatureCollection',
        features: t
      }
      const i = e === r.MULTI ? this.multi_layer : this.single_layer
      i && (t.length > 0 && (i == null || i.setData(s)), t.length === 0 && (i == null || i.clearData()))
    }
    createLayers() {
      let t, e
      ;((t = this.own.getOptions().renderSingleStyle) === null || void 0 === t ? void 0 : t.type) === i.DOM
        ? (this.single_layer = this.createLayer(r.SINGLE, i.DOM))
        : (this.single_layer = this.createLayer(r.SINGLE, i.WEBGL)),
        ((e = this.own.getOptions().renderClusterStyle) === null || void 0 === e ? void 0 : e.type) === i.DOM
          ? (this.multi_layer = this.createLayer(r.MULTI, i.DOM))
          : (this.multi_layer = this.createLayer(r.MULTI, i.WEBGL))
    }
    createLayer(t, s) {
      this.showLog && console.log('创建图层', s)
      let o
      const n = this.own.getOptions()
      const l = t === r.MULTI ? n.renderClusterStyle : n.renderSingleStyle
      if (!l) return
      if (s === i.DOM) {
        const e = {
          sliceRepeat: !0,
          minZoom: this.own.getOptions().minZoom,
          maxZoom: this.own.getOptions().maxZoom,
          zIndex: t === r.MULTI ? 10 : 9,
          nextTick: !0,
          fixBottom: !0,
          anchors: [0.5, 0.5],
          enableDraggingMap: !0
        }
        Object.assign(e, l.style)
        const s = new BMapGL.CustomHtmlLayer(l.inject, e)
        this.map.addCustomHtmlLayer(s), (o = s)
      } else {
        const e = 1.2 * (n.clusterRadius || 32)
        const s = {
          iconObj: (t, e) => ({
            canvas: (l == null ? void 0 : l.inject)(e),
            id: e.clusterId
          }),
          sizes: [e, e / 2],
          scale: 1,
          userSizes: !1,
          anchors: [0, 0],
          width: e,
          height: e / 2
        }
        Object.assign(s, l.style)
        const i = {
          icon: 'https://webmap0.bdimg.com/image/api/marker_red.png',
          sizes: [8, 8],
          anchors: [0, -1],
          userSizes: !1,
          width: ['match', ['get', 'type'], 0, 16, 8],
          height: ['match', ['get', 'type'], 0, 16, 8]
        }
        Object.assign(i, l.style)
        const h = new BMapGL.PointIconLayer({
          minZoom: this.own.getOptions().minZoom,
          maxZoom: this.own.getOptions().maxZoom,
          zIndex: t === r.MULTI ? 10 : 9,
          isTop: true,
          enablePicked: !0,
          autoSelect: !1,
          pickWidth: 30,
          pickHeight: 30,
          opacity: 1,
          isFlat: !1,
          isFixed: !0,
          style: t === r.MULTI ? s : i
        })
        this.map.addNormalLayer(h), (o = h)
      }
      o.addEventListener('click', (t) => {
        if ((this.showLog && console.log('鼠标点击事件', t), t.target instanceof BMapGL.PointIconLayer && !t.value.dataItem)) return
        const s = this.getElementByEvent(t)
        s.bbox && Array.isArray(s.bbox) && s.bbox[0] !== 1 / 0 && this.fitView(s.bbox), this.own.fire(e.CLICK, s)
      })
      const h = s === i.DOM ? 'mouseover' : 'mousemove'
      return (
        o.addEventListener(h, (t) => {
          if ((this.showLog && console.log('鼠标悬浮事件', t), t.target instanceof BMapGL.PointIconLayer && !t.value.dataItem)) {
            return void (this._preMouseMove && (this.own.fire(e.MOUSE_OUT, this._preMouseMove), (this._preMouseMove = null)))
          }
          const s = this.getElementByEvent(t)
          if (t.target instanceof BMapGL.PointIconLayer) {
            return (this._preMouseMove && this._preMouseMove.id === s.id) || this.own.fire(e.MOUSE_OVER, s), void (this._preMouseMove = s)
          }
          this.own.fire(e.MOUSE_OVER, s)
        }),
        o.addEventListener('mouseout', (t) => {
          if ((this.showLog && console.log('鼠标移开事件', t), t.target instanceof BMapGL.PointIconLayer)) {
            return
          }
          const s = this.getElementByEvent(t)
          this.own.fire(e.MOUSE_OUT, s)
        }),
        o
      )
    }
    getElementByEvent(t) {
      let e, s
      if (t.target instanceof BMapGL.CustomOverlay) {
        const i = t.target.properties || {}
        ;(e = i.clusterId), (s = i.clusterIndex)
      } else {
        const i = t.value.dataItem.properties || {}
        ;(e = i.clusterId), (s = i.clusterIndex)
      }
      const i = this.engine.getElementById(e, s)
      return (i.pixel = [t.pixel.x, t.pixel.y]), (i.target = t.target), i
    }
    clearRender() {
      this.showLog && console.log('清除图层'), this.update([[], []])
    }
    unrender() {
      this.showLog && console.log('销毁图层'),
        this.multi_layer instanceof BMapGL.PointIconLayer ? this.map.removeNormalLayer(this.multi_layer) : this.map.removeCustomHtmlLayer(this.multi_layer),
        this.single_layer instanceof BMapGL.PointIconLayer ? this.map.removeNormalLayer(this.single_layer) : this.map.removeCustomHtmlLayer(this.single_layer),
        (this.multi_layer = void 0),
        (this.single_layer = void 0)
    }
    fitView(t) {
      if ((this.showLog && console.log('fitView', t), this.own.getOptions().fitViewOnClick)) {
        const e = this.map.getZoom()
        const s = [new BMapGL.Point(t[0], t[1]), new BMapGL.Point(t[2], t[3])]
        const i = {
          margins: this._fitViewMargin,
          enableAnimation: !0
        }
        this.map.setViewport(s, i),
          setTimeout(() => {
            e === this.map.getZoom() && this.map.setZoom(e + 1), this.mapStatusChange()
          }, 300)
      }
    }
    show() {
      try {
        this.single_layer &&
          (this.single_layer instanceof BMapGL.CustomHtmlLayer && this.single_layer.show?.(),
          this.single_layer instanceof BMapGL.PointIconLayer && this.single_layer.setVisible?.(!0))
      } catch (e) {
        console.log(e)
      }
      // this.single_layer && (this.single_layer instanceof BMapGL.CustomHtmlLayer && this.single_layer.show?.(),
      //         this.single_layer instanceof BMapGL.PointIconLayer && this.single_layer.setVisible?.(!0)),
      try {
        this.multi_layer &&
          (this.multi_layer instanceof BMapGL.CustomHtmlLayer && this.multi_layer.show(),
          this.multi_layer instanceof BMapGL.PointIconLayer && this.multi_layer.setVisible(!0))
      } catch (e) {
        console.log(e)
      }
    }
    hide() {
      try {
        this.single_layer &&
          (this.single_layer instanceof BMapGL.CustomHtmlLayer && this.single_layer.hide?.(),
          this.single_layer instanceof BMapGL.PointIconLayer && this.single_layer.setVisible?.(!1))
      } catch (e) {
        console.log(e)
      }
      // this.single_layer && (this.single_layer instanceof BMapGL.CustomHtmlLayer && this.single_layer.hide?.(),
      //         this.single_layer instanceof BMapGL.PointIconLayer && this.single_layer.setVisible?.(!1)),
      try {
        this.multi_layer &&
          (this.multi_layer instanceof BMapGL.CustomHtmlLayer && this.multi_layer.hide(),
          this.multi_layer instanceof BMapGL.PointIconLayer && this.multi_layer.setVisible(!1))
      } catch (e) {
        console.log(e)
      }
    }
    getSingleLayer() {
      return this.single_layer
    }
    getClusterLayer() {
      return this.multi_layer
    }
    drawMarker(t) {
      this.map.addOverlay(new BMapGL.Marker(new BMapGL.Point(t[0], t[1])))
    }
    destroy() {
      this.map && (this.unregister(), this.unrender())
    }
  }
  let P = Object.freeze({
    __proto__: null,
    get ClusterData() {
      return r
    },
    ClusterElement: F,
    get ClusterEvent() {
      return e
    },
    get ClusterRender() {
      return i
    },
    get ClusterType() {
      return s
    },
    View: class extends t {
      constructor(t, e) {
        if ((super(), (this._showLog = !1), !t)) throw new Error('map is required')
        e && this.verifyOptions(e)
        const s = {
          tileSize: 256,
          minZoom: 3,
          maxZoom: 21,
          clusterRadius: 30,
          clusterMinZoom: 3,
          clusterMaxZoom: 16,
          clusterMinPoints: 3,
          clusterPointWeight: void 0,
          clusterMap: (t) => ({}),
          clusterReduce: void 0,
          clusterType: void 0,
          clusterDictionary: void 0,
          isRender: !0,
          renderClusterStyle: {
            type: i.DOM,
            style: {},
            inject: (t) => {
              let e = Math.pow(t.pointCount / t.allCount, 0.1)
              let s = document.createElement('div')
              let i = 180 - 180 * e
              let r = 'hsla(' + i + ',100%,30%,0.7)'
              let o = 'hsla(' + i + ',100%,90%,1)'
              let n = 'hsla(' + i + ',100%,30%,1)'
              let l = 'hsla(' + i + ',100%,90%,1)'
              s.style.backgroundColor = r
              let h = Math.round(25 + 30 * Math.pow(t.pointCount / t.allCount, 1 / 6))
              return (
                (s.style.width = s.style.height = h + 'px'),
                (s.style.border = 'solid 1px ' + n),
                (s.style.borderRadius = h / 2 + 'px'),
                (s.style.boxShadow = '0 0 5px ' + l),
                (s.innerHTML = t.pointCount),
                (s.style.lineHeight = h + 'px'),
                (s.style.color = o),
                (s.style.fontSize = '14px'),
                (s.style.textAlign = 'center'),
                (s.style.cursor = 'pointer'),
                s
              )
            }
          },
          renderSingleStyle: {
            type: i.WEBGL,
            style: {},
            inject: (t) => document.createElement('canvas')
          },
          fitViewOnClick: !0,
          updateRealTime: !1,
          waitTime: 300
        }
        ;(this.options = Object.assign(s, e)),
          (this.engine = new S(this, this._showLog)),
          (this.render = new I(this, this.engine, t, this._showLog)),
          (this.isRender = this.options.isRender || !1)
      }
      setData(t) {
        this._showLog && console.log('cluster options', this.options), this.engine.createClusters(t), this.redraw()
      }
      getSingleLayer() {
        return this.render.getSingleLayer()
      }
      getClusterLayer() {
        return this.render.getClusterLayer()
      }
      redraw() {
        this.render.mapStatusChange()
      }
      show() {
        this.render.show()
      }
      hide() {
        this.render.hide()
      }
      destroy() {
        this.fire(e.DESTROY)
      }
      get isRender() {
        return this._isRender
      }
      set isRender(t) {
        ;(this._isRender = t), !t && this.render.clearRender()
      }
      getOptions() {
        return this.options
      }
      verifyOptions(t) {
        let e, s
        if (t.minZoom && t.minZoom < 3) {
          throw new Error('minZoom must be greater than 3')
        }
        if (t.maxZoom && t.maxZoom > 23) throw new Error('maxZoom must be less than 23')
        if (Math.max((e = t.minZoom) !== null && void 0 !== e ? e : 3, 3) > Math.min((s = t.maxZoom) !== null && void 0 !== s ? s : 23, 23)) {
          throw new Error('minZoom must be less than maxZoom')
        }
        if (t.clusterMinZoom && t.clusterMinZoom < 3) {
          throw new Error('clusterMinZoom must be greater than 3')
        }
        if (t.clusterMaxZoom && t.clusterMaxZoom > 23) {
          throw new Error('clusterMaxZoom must be less than 23')
        }
        if (t.clusterMinZoom && t.clusterMaxZoom && t.clusterMinZoom > t.clusterMaxZoom) {
          throw new Error('clusterMinZoom must be less than clusterMaxZoom')
        }
        if (t.clusterType) {
          if (!(t.clusterType instanceof Array)) {
            throw new Error('clusterType must be an array')
          }
          if (t.clusterType.length < 1) {
            throw new Error('clusterType must be greater than 0')
          }
          for (let e = 0; e < t.clusterType.length; e++) {
            if (t.clusterType[e].length < 4) {
              throw new Error('clusterType must be greater than 4')
            }
            if (!t.clusterType[e][0]) {
              throw new Error('clusterType item startZoom must not be null')
            }
            if (t.clusterType[e][1] && t.clusterType[e][0] > t.clusterType[e][1]) {
              throw new Error('clusterType item endZoom must be less than starZoom')
            }
            if (t.clusterType[e][1] === null && e < t.clusterType.length - 1) {
              throw new Error('clusterType item endZoom must not be null,excluding the last item endZoom')
            }
            if (e < t.clusterType.length - 1 && t.clusterType[e][1] !== null && t.clusterType[e][1] > t.clusterType[e + 1][0]) {
              throw new Error('clusterType item endZoom must be less than the next startZoom')
            }
          }
        }
      }
    },
    pointTransformer: (t, e) => {
      const s = []
      return (
        t.forEach((t) => {
          const { point: i = null, properties: r = {} } = e(t)
          i &&
            s.push({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: i
              },
              properties: r
            })
        }),
        s
      )
    }
  })
  return P
})`
